import React from "react";
import CustomSelect from "../common/Select";

function SelectorConvenio({ value, onChange, error, required = false, convenios = [] }) {
  // Convertir convenios a formato de opciones
  const opcionesConvenio = convenios.map(convenio => ({
    value: convenio.id,
    label: convenio.nombre
  }));

  return (
    <CustomSelect
      options={opcionesConvenio}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Convenio"
      error={error}
      required={required}
    />
  );
}

export default SelectorConvenio;